import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pt-summary',
  templateUrl: './pt-summary.component.html',
  styleUrls: ['./pt-summary.component.css']
})
export class PtSummaryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
